/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */
import axios from 'axios'
import type {
  AxiosRequestConfig,
  AxiosResponse,
  AxiosError
} from 'axios'
import {
  useQuery,
  useMutation
} from '@tanstack/react-query'
import type {
  UseQueryOptions,
  UseMutationOptions,
  QueryFunction,
  MutationFunction,
  UseQueryResult,
  QueryKey
} from '@tanstack/react-query'
import type {
  GetPaymentGatewaysResponse,
  CreatePaymentResponse,
  CreatePaymentRequest
} from './schema'



export const utxPaymentGatewayGetPaymentGateways = (
     options?: AxiosRequestConfig
 ): Promise<AxiosResponse<GetPaymentGatewaysResponse>> => {
    return axios.get(
      `/payment-gateway`,options
    );
  }


export const getUtxPaymentGatewayGetPaymentGatewaysQueryKey = () => [`/payment-gateway`];

    
export type UtxPaymentGatewayGetPaymentGatewaysQueryResult = NonNullable<Awaited<ReturnType<typeof utxPaymentGatewayGetPaymentGateways>>>
export type UtxPaymentGatewayGetPaymentGatewaysQueryError = AxiosError<void>

export const useUtxPaymentGatewayGetPaymentGateways = <TData = Awaited<ReturnType<typeof utxPaymentGatewayGetPaymentGateways>>, TError = AxiosError<void>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof utxPaymentGatewayGetPaymentGateways>>, TError, TData>, axios?: AxiosRequestConfig}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const {query: queryOptions, axios: axiosOptions} = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getUtxPaymentGatewayGetPaymentGatewaysQueryKey();

  

  const queryFn: QueryFunction<Awaited<ReturnType<typeof utxPaymentGatewayGetPaymentGateways>>> = ({ signal }) => utxPaymentGatewayGetPaymentGateways({ signal, ...axiosOptions });

  const query = useQuery<Awaited<ReturnType<typeof utxPaymentGatewayGetPaymentGateways>>, TError, TData>(queryKey, queryFn, queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey;

  return query;
}

export const utxPaymentGatewayCreatePayment = (
    createPaymentRequest: CreatePaymentRequest, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<CreatePaymentResponse>> => {
    return axios.post(
      `/payment-gateway/payment`,
      createPaymentRequest,options
    );
  }



    export type UtxPaymentGatewayCreatePaymentMutationResult = NonNullable<Awaited<ReturnType<typeof utxPaymentGatewayCreatePayment>>>
    export type UtxPaymentGatewayCreatePaymentMutationBody = CreatePaymentRequest
    export type UtxPaymentGatewayCreatePaymentMutationError = AxiosError<void>

    export const useUtxPaymentGatewayCreatePayment = <TError = AxiosError<void>,
    
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof utxPaymentGatewayCreatePayment>>, TError,{data: CreatePaymentRequest}, TContext>, axios?: AxiosRequestConfig}
) => {
      const {mutation: mutationOptions, axios: axiosOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof utxPaymentGatewayCreatePayment>>, {data: CreatePaymentRequest}> = (props) => {
          const {data} = props ?? {};

          return  utxPaymentGatewayCreatePayment(data,axiosOptions)
        }

      return useMutation<Awaited<ReturnType<typeof utxPaymentGatewayCreatePayment>>, TError, {data: CreatePaymentRequest}, TContext>(mutationFn, mutationOptions)
    }
    